import React, { Component } from "react";
import styles from "./winterMaintenceMapWrapper.module.scss";
import { DataGrid } from "@mui/x-data-grid";
import getDates from "../../../shared/services/date.service";
import clsx from "clsx";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import { dateGridLocalTextOptions } from "../../../shared/services/dataGridLocalTextOptions";

const codeCroups = {
  "23b50564-39ed-11ef-8bc9-0242ac110004": "Дор. маш. (СО)",
  "23b3ad9a-39ed-11ef-8bc9-0242ac110004": "ПСР",
  "23b5f60e-39ed-11ef-8bc9-0242ac110004": "Погр. снг. (ГР)",
  "23b6d1aa-39ed-11ef-8bc9-0242ac110004": "Самосв. трак. (ГР)",
};

class WinterMaintenceUnitsTable extends Component {
  getColumns() {
    const sensorCellStyle = (params) => {
      return clsx("sensorCell", {
        positive: params.value,
      });
    };

    const dumpLongInactiveCellStyle = (params) => {
      return clsx("sensorCell", {
        negative: params.row.time !== null && params.row.dumpSensorLongInaction,
        positive: false,
      });
    };

    const sandLongInactiveCellStyle = (params) => {
      return clsx("sensorCell", {
        negative: params.row.time !== null && params.row.sandSensorLongInaction,
      });
    };

    const renderGroupCell = (params) => {
      return (
        <div style={{ display: "flex" }}>
          {params.value.map((group, index) => {
            return (
              <div key={index}>
                <TooltipWrapper title={group.title} position="top">
                  <div style={{ marginRight: "3px" }}>{codeCroups[group.id]};</div>
                </TooltipWrapper>
              </div>
            );
          })}
        </div>
      );
    };

    const renderTitleCell = (params) => {
      return (
        <a href={`/cars/${params.row.id}/intimerange`} target="_blank" rel="noreferrer">
          {params.row.registerNumber}
        </a>
      );
    };

    return [
      {
        field: "number",
        headerName: "",
        width: 15,
      },
      {
        field: "registerNumber",
        headerName: "Рег. номер ",
        renderCell: renderTitleCell,
        width: 120,
      },
      {
        field: "title",
        headerName: "Подпись",
        width: 200,
      },

      {
        field: "isDumpSensor",
        headerName: "Датчик отвала",
        type: "boolean",
        cellClassName: sensorCellStyle,
        width: 100,
      },
      {
        field: "isSandSensor",
        headerName: "Датчик ПСС",
        type: "boolean",
        cellClassName: sensorCellStyle,
        width: 100,
      },
      {
        field: "time",
        headerName: "Время последних данных",
        width: 160,
      },
      {
        field: "timeDump",
        headerName: "Дата сработки отвала",
        cellClassName: dumpLongInactiveCellStyle,
        width: 160,
      },
      {
        field: "timeSand",
        headerName: "Дата сработки ПСС",
        cellClassName: sandLongInactiveCellStyle,
        width: 160,
      },

      {
        field: "groups",
        headerName: "Группы",
        renderCell: renderGroupCell,
        width: 300,
      },
      {
        field: "dumpSensorLongInaction",
        hideable: true,
      },
      {
        field: "sandSensorLongInaction",
        hideable: true,
      },
    ];
  }

  getRows() {
    const { units } = this.props;

    const dateTime = (lastPosition, timeName) => {
      if (lastPosition === null) {
        return null;
      }

      if (lastPosition[timeName].includes("0001-01-01")) {
        return null;
      }

      return getDates.getDateFormat11(lastPosition[timeName]);
    };

    return units.map((unit, i) => {
      return {
        number: i + 1,
        ...unit,
        ...unit.lastPosition,
        /*  groups: unit.groups.map((x) => {
          return x.title;
        }), */
        time: dateTime(unit.lastPosition, "time"),
        timeDump: dateTime(unit.lastPosition, "timeDump"),
        timeSand: dateTime(unit.lastPosition, "timeSand"),
      };
    });
  }

  render() {
    const { units } = this.props;

    const tableSyle = {
      "& .sensorCell.negative": {},
      "& .sensorCell.positive": {
        backgroundColor: "rgba(157, 255, 118, 0.49)",
      },
    };

    return (
      <div>
        <DataGrid
          className={styles.MuiButtonBase_resolve}
          sx={tableSyle}
          rowHeight={30}
          ref={"DataGrid"}
          localeText={{
            ...dateGridLocalTextOptions,
            footerRowSelected: (count) => `Транспортных средств выбранно: ${count}`,
            MuiTablePagination: {
              disabled: true,
              rowsPerPage: 100,
              rowsPerPageOptions: 100,
              backIconButtonProps: null,
              labelDisplayedRows: ({ from, to, count }) => `Показанно транспортных средств: ${count}`,
            },
          }}
          initialState={{
            columns: {
              columnVisibilityModel: {
                dumpSensorLongInaction: false,
                sandSensorLongInaction: false,
              },
            },
          }}
          checkboxSelection={false}
          rows={this.getRows()}
          columns={this.getColumns()}
          disableRowSelectionOnClick
        />
      </div>
    );
  }
}

export default React.memo(WinterMaintenceUnitsTable);
